import React from "react";
import { ToastContainer } from "react-toastify";

const FreeItemsSettings = ({
  freeItemForm,
  handleFreeItemChange,
  handleSubmitFreeItem,
  catalogueStore,
  expandedCategory,
  setExpandedCategory,
  setFreeItemForm,
}) => {
  return (
    <>
    <ToastContainer/>
    
    <div className="grid md:grid-cols-2 gap-6 montserrat-font-1">
      {/* LEFT */}
      <div className="bg-white p-6 rounded-2xl">
        <h2 className="text-green-700 font-semibold text-lg mb-6">
          Select Free Item
        </h2>

        <div className="space-y-4">
          {/* Min Amount */}
          <div>
            <label className="text-sm text-gray-700">
              Minimum Order Amount
            </label>
            <input
              type="text"
              name="minAmount"
              value={freeItemForm.minAmount}
              onChange={handleFreeItemChange}
              placeholder="Enter Minimum Order Amount"
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            />
          </div>

          {/* Customer Type */}
          <div>
            <label className="text-sm text-gray-700">Customer Type</label>
            <select
              name="customerType"
              value={freeItemForm.customerType}
              onChange={handleFreeItemChange}
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            >
              <option value="first_time">First Time User Only</option>
              <option value="all">All Users</option>
            </select>
          </div>

          {/* Selected Item */}
          <div>
            <label className="text-sm text-gray-700">Selected Free Item</label>
            <p className="text-sm text-gray-500 mt-1">
              {freeItemForm.selectedItem ? (
                <div className="mt-2 border rounded-lg p-3 flex items-center gap-3 bg-gray-50">
                  {/* Image */}
                  <img
                    src={freeItemForm.selectedItem.photo}
                    alt=""
                    className="w-12 h-12 rounded object-cover"
                  />

                  {/* Details */}
                  <div className="flex flex-col">
                    {/* Item Name */}
                    <span className="text-sm font-medium text-gray-800">
                      {freeItemForm.selectedItem.item_name}
                    </span>

                    {/* Category Name */}
                    <span className="text-xs text-gray-500">
                      {freeItemForm.selectedItem.category_name || "Category"}
                    </span>

                    {/* Price */}
                    <span className="text-xs text-green-600 font-medium">
                      {freeItemForm.selectedItem?.prices?.[0]?.formatted_price}
                    </span>
                  </div>
                </div>
              ) : (
                <p className="text-sm text-gray-500 mt-1">No item selected</p>
              )}
            </p>
          </div>

          {/* Submit */}
          <button
            onClick={handleSubmitFreeItem}
            className="w-full bg-green-700 hover:bg-green-800 text-white py-2 rounded-lg mt-5"
          >
            Submit
          </button>
        </div>
      </div>

      {/* RIGHT */}
      <div className="bg-white p-6 rounded-2xl max-h-[450px] overflow-y-auto">
        <h2 className="text-gray-800 font-semibold mb-4">
          Choose a free item from menu
        </h2>

        {catalogueStore.map((cat) => (
          <div key={cat.cat_id} className="mb-4">
            {/* Category */}
            <div
              onClick={() =>
                setExpandedCategory(
                  expandedCategory === cat.cat_id ? null : cat.cat_id,
                )
              }
              className="flex justify-between items-center cursor-pointer bg-white px-3 py-2 rounded-lg shadow-sm"
            >
              <span className="font-medium text-gray-700">
                {cat.category_name}
              </span>
              <span>▾</span>
            </div>

            {/* Items */}
            {expandedCategory === cat.cat_id && (
              <div className="mt-2 space-y-2">
                {cat.menu_items.map((item) => (
                  <div
                    key={item.item_id}
                    className="flex items-center gap-3 bg-white p-2 rounded-lg border"
                  >
                    <input
                      type="radio"
                      name="freeItem"
                      checked={
                        freeItemForm.selectedItem?.item_id === item.item_id
                      }
                      onChange={() =>
                        setFreeItemForm((prev) => ({
                          ...prev,
                          selectedItem: item,
                        }))
                      }
                    />

                    <img
                      src={item.photo}
                      alt=""
                      className="w-12 h-12 rounded object-cover"
                    />

                    <div>
                      <p className="text-sm font-medium">{item.item_name}</p>
                      <p className="text-xs text-gray-500">
                        {item?.prices?.[0]?.formatted_price}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default FreeItemsSettings;
